export default __webpack_public_path__ + "static/media/snow-img.e7f06811.svg";